var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1998_92555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.88087 2.6875L1.07744 11.4916C1.03315 11.536 1.00117 11.5921 0.985939 11.6524L0.0101637 15.5689C-0.0190245 15.6868 0.0156207 15.8122 0.101663 15.8982C0.166765 15.9633 0.255472 15.9994 0.346209 15.9994C0.374002 15.9994 0.402428 15.9959 0.430094 15.989L4.34665 15.0131C4.40769 14.9978 4.46315 14.966 4.50744 14.9217L13.3116 6.11826L9.88087 2.6875Z",
    fill: "#1D4650"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4926 1.48657L14.5126 0.506606C13.8577 -0.148353 12.7162 -0.147718 12.062 0.506606L10.8616 1.707L14.2922 5.13764L15.4926 3.93724C15.8198 3.6102 16 3.17492 16 2.71197C16 2.24902 15.8198 1.81373 15.4926 1.48657Z",
    fill: "#1D4650"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1998_92555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.31bb41a43efe950739881a6e55f7013f.svg";
export { ForwardRef as ReactComponent };